import { render, staticRenderFns } from "./ClubCrud.vue?vue&type=template&id=8a02e050&scoped=true&"
import script from "./ClubCrud.vue?vue&type=script&lang=js&"
export * from "./ClubCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a02e050",
  null
  
)

export default component.exports